export const FAVORITES_IS_LOADING = 'FAVORITES_IS_LOADING';
export const FAVORITE_SAVING = 'FAVORITE_SAVING';
export const FAVORITE_SAVED = 'FAVORITE_SAVED';
export const FAVORITES_FETCHED = 'FAVORITES_FETCHED';



// WEBPACK FOOTER //
// ./src/data/constants/favorites.js